module.exports = __webpack_public_path__ + "img/8.6e7435cf.png";